// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"S3-z","colorTextValue":"T3-z","swatches":"U3-z","collapseLink":"V3-z","isCollapsed":"W3-z","dropdown":"X3-z","disabled":"Y3-z"};